module.exports = __webpack_public_path__ + "img/SKMJ_road1.90f689a3.jpg";